var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.322,
    height: 16.922,
    viewBox: "0 0 26.322 16.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(-1.88 -6.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2580",
    "data-name": "Raggruppa 2580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3395",
    "data-name": "Tracciato 3395",
    d: "M1.88,15.04a.94.94,0,0,1,.94-.94H24.991L19.074,8.186a.941.941,0,1,1,1.331-1.331l7.52,7.52a.94.94,0,0,1,0,1.331l-7.52,7.52a.941.941,0,1,1-1.331-1.331l5.916-5.914H2.82A.94.94,0,0,1,1.88,15.04Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow_right_icon.86e1810f60f560d7fdf4ed49a7bddfce.svg";
export { ForwardRef as ReactComponent };